import {createFeatureSelector, createSelector, createSelectorFactory, MemoizedProjection} from '@ngrx/store';
import { State } from './reports.reducer';
import {AnyFn} from '@ngrx/store/src/selector';

export const getReportsFeature = createFeatureSelector<State>('reports');

export function isEqual(a: any, b: any): boolean {
    return a.totalRows === b.totalRows &&
        a.reports.every(fromA => b.reports.includes(fromA));
}

export function customMemoize(t: AnyFn): MemoizedProjection {
    let lastResult: any = null;

    function memoized(): any {
        const result = t.apply(null, arguments);

        if (lastResult == null || !isEqual(result, lastResult)) {
            lastResult = result;
            return result;
        }
        return lastResult;
    }

    function reset() { lastResult = null; }

    return {
        clearResult(): void {
        }, setResult(result: any): void {
        }, memoized, reset};
}

export const getReports = createSelectorFactory(customMemoize)(
    getReportsFeature,
    (state) => {
        return {
            reports: state.reports,
            totalRows: state.totalRows,
            currentLazyLoad: state.currentLazyLoad
        };
    }
);

export const getGeneralSettings = createSelector(
    getReportsFeature,
    (state) => {
        return state.settings;
    }
);
